/* eslint-disable unicorn/filename-case -- legacy Upload*.tsx naming */
import { useOptionalModalAction } from "@components/common/CustomModal";
import { Delete, Edit, FileDownload, FileOpen } from "@mui/icons-material";
import { Button, ButtonGroup } from "@mui/material";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { useDeleteFileMutation } from "@/libs/generated/hooks";

import type { UploadActionsProps } from "./types";

function DeleteButton({ id, disabled, cb }: { id: string; disabled: boolean; cb?: () => void }) {
  const { t } = useTranslation();
  const modalAction = useOptionalModalAction();
  const deleteFile = useDeleteFileMutation({
    onSuccess: async () => {
      cb?.();
      if (modalAction !== null && modalAction !== undefined) {
        await modalAction.handleConfirmAction();
      }
    },
  });
  const loading = deleteFile.isPending;
  const error = deleteFile.error;
  if (error !== null && error !== undefined) {
    toast.error(t("common.actions.delete-error"));
  }
  return (
    <Button
      variant="contained"
      color="error"
      startIcon={<Delete />}
      onClick={() => deleteFile.mutate({ key: id })}
      disabled={disabled || loading}
    >
      {t("common.actions.delete")}
    </Button>
  );
}
export function UploadActions({
  id,
  onOpen,
  onChange,
  canOpen = true,
  canChange = true,
  loading = false,
  onDelete,
  onDownload,
  canDelete = true,
  readyOnly = false,
}: UploadActionsProps) {
  const { t } = useTranslation();
  return (
    <ButtonGroup>
      <Button
        color="info"
        variant="contained"
        onClick={onOpen}
        disabled={!canOpen || loading}
        startIcon={<FileOpen />}
      >
        {t("common.actions.open-btn")}
      </Button>
      {/* download */}
      <Button
        color="warning"
        variant="contained"
        onClick={onDownload}
        disabled={!canOpen || loading}
        startIcon={<FileDownload />}
      >
        {t("common.actions.download")}
      </Button>
      {!readyOnly && (
        <Button
          variant="contained"
          onClick={onChange}
          disabled={!canChange || loading}
          startIcon={<Edit />}
        >
          {t("common.actions.edit")}
        </Button>
      )}
      {!readyOnly && <DeleteButton id={id!} disabled={!canDelete || loading} cb={onDelete} />}
    </ButtonGroup>
  );
}
